export enum UserRole {
    User = 1,
    Coach = 2,
    TeamManager = 4,
    QualityManager = 8,
    Admin = 16
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/user-role.ts